const Shopify = window.Shopify;
Shopify.queryParams = {};

// Preserve existing query parameters
if (location.search.length) {
    const params = location.search.slice(1).split("&");

    for (const param of params) {
        const [key, value] = param.split("=");
        if (value) {
            Shopify.queryParams[key] = value;
        }
    }
}
